export default __webpack_public_path__ + "static/media/cht.c37ec70a.svg";